export default "__VITE_ASSET__B_Y3Z_o2__"